const ITEMS = ["STRONG FRAMES.", "SOLID FUTURE."];

export const Marquee = () => (
  <div
    data-testid="tagline-marquee"
    className="bg-brand-ink border-y border-white/10 py-5 overflow-hidden select-none"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0">
          {Array.from({ length: 4 }).map((_, i) =>
            ITEMS.map((t, j) => (
              <span key={`${i}-${j}`} className="flex items-center">
                <span
                  className={`font-display text-3xl sm:text-5xl font-semibold uppercase tracking-wide whitespace-nowrap px-8 ${
                    j % 2 === 0 ? "text-white" : "text-outline"
                  }`}
                >
                  {t}
                </span>
                <span className="w-3 h-3 bg-brand-red shrink-0" />
              </span>
            ))
          )}
        </div>
      ))}
    </div>
  </div>
);
